import {
    ViewFactory,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';

import ONVStartpageView from './ONVStartpageView';
import ONVStartpageViewModel from './ONVStartpageViewModel';

class ONVStartpageViewFactory extends ViewFactory
{
    private readonly StartpageViewModel: typeof ONVStartpageViewModel;
    private readonly StartpageView: typeof ONVStartpageView;

    constructor(params: any)
    {
        super(params);
        this.StartpageViewModel = ComponentManager.getViewModel<typeof ONVStartpageViewModel>('ONVStartpageViewModel');
        this.StartpageView = ComponentManager.getView<typeof ONVStartpageView>('ONVStartpageView');
    }

    public getView(): JQuery<HTMLElement> {
        this.resolveDependencies(['Wireframe']);
        
        if (this.viewModel == null || this.viewModel.isDisposed)
        {
            this.viewModel = new this.StartpageViewModel({
                locator: 'onvstartpage',
                viewFactory: this
            });
        }
        if (this.view == null)
        {
            this.view = new this.StartpageView(this.viewModel, this.createRootElement('ONVStartpage'));
        }

        this.setPageTitle('ONV Dashboard');

        let tuple = this.view.getTuple();
        return tuple.view;
    }

}

ComponentManager.setFactory('ONVStartpage', ONVStartpageViewFactory, 'ONVHTMLViewExtension');
ComponentManager.setFactory('Startpage', ONVStartpageViewFactory, 'ONVHTMLViewExtension');